// extracted by mini-css-extract-plugin
export const root = "team-bios-module--root--qDlCC typography-module--large--1Oqox";